import React from "react";
import Homepage from "../pages/Homepage";

export const Home = () => {
  return (
    <section>
      <Homepage />
    </section>
  );
};
